import { useEffect } from "react";

const BASE = "Sarah Atkinson Advisory";

export default function usePageTitle(title) {
  useEffect(() => {
    document.title = title ? `${title} · ${BASE}` : `${BASE} — Airbnb Consulting & STR Strategy`;
  }, [title]);
}
